import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('filbox_cookie_consent');
        if (!consent) {
            // Biraz gecikmeli göstererek sayfa açılışını rahatlatalım
            const timer = setTimeout(() => setIsVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem('filbox_cookie_consent', 'all');
        setIsVisible(false);
        // İsteğe bağlı: Çerez onaylandığında scriptleri hemen tetikleyebilirsiniz.
        if (window.loadExternalScripts) {
            window.loadExternalScripts();
        }
    };

    const handleAcceptNecessary = () => {
        localStorage.setItem('filbox_cookie_consent', 'necessary');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div data-nosnippet className="fixed bottom-0 left-0 z-[9999] p-4 md:p-6 pointer-events-none w-full sm:w-auto">
            <div className="relative max-w-[430px] w-full pointer-events-auto" style={{ fontFamily: "'Outfit', sans-serif" }}>
                {/* Mor projeksiyon ışığı */}
                <div
                    className="absolute -inset-4 pointer-events-none"
                    style={{ background: 'radial-gradient(ellipse at 30% 80%, rgba(164,144,194,0.35), transparent 65%)' }}
                />

                {/* Bilet */}
                <div className="relative flex bg-[#f5f0e6] text-[#241c30] shadow-[0_16px_40px_rgba(84,58,120,0.45)]">
                    {/* Sol perfore şerit */}
                    <div
                        className="w-[10px] shrink-0"
                        style={{ background: 'repeating-linear-gradient(180deg, #7c63a6 0 10px, #f5f0e6 10px 16px)' }}
                    />

                    {/* Gövde */}
                    <div className="flex-1 p-4 md:px-5 border-r-2 border-dashed border-[#a490c2]">
                        <div className="flex items-center justify-between mb-1.5">
                            <span className="font-mono text-[10px] tracking-[2px] text-[#7c63a6] font-bold">
                                FILBOX · GİRİŞ BİLETİ
                            </span>
                            <span className="font-mono text-[9px] px-1.5 py-0.5 border border-[#a490c2] text-[#7c63a6] rounded-[2px] -rotate-3">
                                ONAYLI ✦
                            </span>
                        </div>

                        <h4 className="font-bold text-[15px] mb-1 text-[#241c30]">
                            Çerezler koltuğunuzu ayırıyor
                        </h4>
                        <p className="text-[12.5px] leading-relaxed text-[#544a63]">
                            Deneyimi ve önerileri iyileştirmek için çerez kullanıyoruz.{' '}
                            <Link
                                to="/yasal/aydinlatma"
                                className="text-[#7c63a6] font-semibold underline underline-offset-2 hover:text-[#5d4784]"
                            >
                                Çerez Politikası
                            </Link>
                        </p>

                        <div className="flex gap-2 mt-3">
                            <button
                                onClick={handleAcceptAll}
                                className="px-4 py-2 bg-[#7c63a6] text-[#f5f0e6] text-xs font-bold shadow-[3px_3px_0_#241c30] hover:bg-[#6a538f] active:translate-x-[2px] active:translate-y-[2px] active:shadow-[1px_1px_0_#241c30] transition-all"
                            >
                                Kabul et
                            </button>
                            <button
                                onClick={handleAcceptNecessary}
                                className="px-3.5 py-2 bg-transparent text-[#544a63] text-xs font-semibold border border-[#a490c2] hover:bg-[#a490c2]/15 transition-colors"
                            >
                                Sadece zorunlular
                            </button>
                        </div>
                    </div>

                    {/* Koçan */}
                    <div
                        className="w-[54px] shrink-0 hidden sm:flex items-center justify-center"
                        style={{ background: 'linear-gradient(180deg, rgba(164,144,194,0.12), rgba(124,99,166,0.22))' }}
                    >
                        <span
                            className="font-mono text-[9px] text-[#7c63a6] tracking-[3px] font-bold"
                            style={{ writingMode: 'vertical-rl' }}
                        >
                            SALON 01 · SIRA C
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
